const baseUrl = "/consumer-engine";

export default {
  baseUrl,
  CONFIGURATION_SOURCES: `${baseUrl}/identity-resolution/sources`,
  CONFIGURATION_ENTITY_UNIFICATION: `${baseUrl}/identity-resolution/rule-sets`,
  CONFIGURATION_FIELD_VALIDATOR: `${baseUrl}/identity-resolution/validators`,

  CONFIGURATION_GOLDEN_RECORD: `${baseUrl}/golden-record/configuration`,

  OPERATIONS_MONITORING: `${baseUrl}/operations/engine-job-monitoring`,
  SURVEY_OUTPUT_MAPPING_SURVEYS: `${baseUrl}/operations/web-form-mappings`,
  SURVEY_TARGET_MODEL_MANAGEMENT: `${baseUrl}/operations/web-form-models`,
  CONSUMER_POPULATIONS: `${baseUrl}/operations/consumer-populations`,
};
